import { includes } from "lodash";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import utils from "../../../app/js/utils";

const useScrollToError = ({ panels, setPanels }) => {
    const containerRef = useRef(null);
    const dispatch = useDispatch();

    const expandedErrorPanels = useSelector((state) => state.utilsReducer.panelsToExpand);
    const checkErrorPanels = useSelector((state) => state.utilsReducer.checkErrorPanels);
    const scrollToError = useSelector((state) => state.utilsReducer.scrollToError);

    const toggleCheckErrorPanels = (value) => {
        dispatch(utils.actions.toggleCheckErrorPanels(value));
    };

    const toggleSnackBar = (open, variant, message) => {
        dispatch(utils.operations.snackbar(open, variant, message));
    };

    const togglePanel = (panel, open) => {
        const updatedPanels = { ...panels };
        updatedPanels[panel] = open;
        setPanels(updatedPanels);
    };

    useEffect(() => {
        if (!checkErrorPanels && !scrollToError) return;

        if (panels != null) {
            const updatedPanels = Object.fromEntries(
                Object.keys(panels)
                    .filter((key) => includes(expandedErrorPanels, key))
                    .filter((key) => !(key === "property" && panels.property !== false))
                    .map((key) => [key, true])
            );

            setPanels((prev) => ({ ...prev, ...updatedPanels }));
        }

        if (checkErrorPanels) toggleCheckErrorPanels(false);
        if (scrollToError) dispatch(utils.actions.setScrollToError(false));

        setTimeout(() => {
            const firstErrorHelper = containerRef.current?.querySelector('[data-testid="ErrorIcon"]');
            if (!firstErrorHelper) return;

            firstErrorHelper.scrollIntoView({ behavior: "smooth", block: "center" });
            const formControl = firstErrorHelper.closest(".MuiFormControl-root") ?? firstErrorHelper.closest("div");
            const labelElement = formControl?.querySelector("label, legend, .MuiFormLabel-root");
            const ariaLabelElement = formControl?.querySelector("[aria-label]");
            const labelText = labelElement?.textContent || ariaLabelElement?.getAttribute("aria-label");
            const message = labelText
                ? `${utils.operations.toTitleCase(labelText)} is invalid`
                : "Please correct the errors before submitting";
            toggleSnackBar(true, "error", message);
        }, 600);
    }, [expandedErrorPanels, scrollToError]);

    return { containerRef, togglePanel };
};

export default useScrollToError;
